import { render, staticRenderFns } from "./Database_glossary.vue?vue&type=template&id=153e18a6&scoped=true"
import script from "./Database_glossary.vue?vue&type=script&lang=js"
export * from "./Database_glossary.vue?vue&type=script&lang=js"
import style0 from "./Database_glossary.vue?vue&type=style&index=0&id=153e18a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e18a6",
  null
  
)

export default component.exports